module.exports = __webpack_public_path__ + "assets/images/lectura-math-small.c0634c90096ced9a91db0a384d9037f0.svg";